module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-04-1e0169a2d7e6c36b89343a00803456b1.webp";